import loSto from '../../config/loSto'
import { LO_STO } from '../constants'
import moment from 'moment'
import client from '../../apollo'
import { LogStory } from '@sukiai/gql/common'

class HalfStory {
    new = () => {
      // Displayed as: 2018-09-19
      const date = moment().format('YYYY-MM-DD')

      const story = {
        date,
        events: []
      }

      loSto.set(LO_STO.HALF_STORY, story)
      return story
    }

    update = event => {
      const updatedStory = loSto.get(LO_STO.HALF_STORY) || this.new()
      const updatedEvents = updatedStory.events || []
      updatedEvents.push(event)
      loSto.set(LO_STO.HALF_STORY, updatedStory)
    }

    save = () => {
      const story = loSto.get(LO_STO.HALF_STORY)

      if (story) {
        console.info('HALF STORY: Saving story!')
        client.mutate({
          mutation: LogStory,
          variables: {
            date: story.date,
            events: story.events
          }
        }).then(({ data }) => {
          if (data.logStory && data.logStory.success) {
            this.clear()
          } else {
            this.save()
          }
        }).catch(err => {
          console.error('Could not log half story on server:', err)
        })
      } else {
        console.info('HALF STORY: No story yet!')
      }
    }

    add = (type, description) => {
      // Displayed as: 12:09:43.157 PM
      const timestamp = moment().format('hh:mm:ss.SSS A')

      // Displayed as: /note/1234
      const route = window.location.pathname

      const event = {
        timestamp,
        type,
        route,
        description
      }

      this.update(event)
    }

    clear = () => {
      loSto.remove(LO_STO.HALF_STORY)
    }
}

const halfstorySingleton = new HalfStory()

export default halfstorySingleton
